"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageStudioReason = void 0;
var ImageStudioReason;
(function (ImageStudioReason) {
    ImageStudioReason[ImageStudioReason["IMAGE"] = 0] = "IMAGE";
    ImageStudioReason[ImageStudioReason["CLOSED"] = 1] = "CLOSED";
})(ImageStudioReason || (exports.ImageStudioReason = ImageStudioReason = {}));
//# sourceMappingURL=ImageStudio.js.map